/**
 * 用于处理牌局数据的编码和解码
 */

/**
 * 将牌局数据编码为 base64 字符串
 * @param {Object} state - 牌局数据
 * @returns {string} - base64 编码的字符串
 */
export const encodeGameState = (state) => {
  const shareableState = {
    v: 1, // 版本号，用于未来可能的数据结构变更
    gameInfo: state.gameInfo,
    heroInfo: state.heroInfo,
    streetActions: state.streetActions,
    board: state.board,
    currentStreet: state.currentStreet,
    potSize: state.potSize,
    lastBetSize: state.lastBetSize,
    activePlayers: state.activePlayers,
    lastAggressivePlayer: state.lastAggressivePlayer,
    playersHands: state.playersHands,
    gameEndedAtStreet: state.gameEndedAtStreet
  };
  
  return btoa(JSON.stringify(shareableState));
};

/**
 * 从 base64 字符串解码牌局数据
 * @param {string} encodedState - base64 编码的字符串
 * @returns {Object} - 牌局数据
 */
export const decodeGameState = (encodedState) => {
  try {
    const data = JSON.parse(atob(encodedState));
    
    // 验证版本号
    if (data.v && data.v !== 1) {
      throw new Error('Unsupported data version');
    }

    // 如果是旧版数据格式，直接返回
    if (!data.v) {
      return data;
    }
    
    return {
      gameInfo: data.gameInfo,
      heroInfo: data.heroInfo,
      streetActions: data.streetActions,
      board: data.board,
      currentStreet: data.currentStreet,
      potSize: data.potSize,
      lastBetSize: data.lastBetSize,
      activePlayers: data.activePlayers,
      lastAggressivePlayer: data.lastAggressivePlayer,
      playersHands: data.playersHands,
      gameEndedAtStreet: data.gameEndedAtStreet
    };
  } catch (error) {
    console.error('Failed to decode game state:', error);
    return null;
  }
};

/**
 * 创建可分享的URL
 * @param {Object} state - 当前游戏状态
 * @returns {string} - 包含编码状态的完整URL
 */
export const createShareableUrl = (state) => {
  const encodedState = encodeGameState(state);
  const url = new URL(window.location.href);
  url.searchParams.set('action', encodedState);
  return url.toString();
};

/**
 * 生成分享链接
 * @param {Object} handData - 牌局数据
 * @returns {string} - 分享链接
 */
export const generateShareLink = (handData) => {
  const encodedData = encodeGameState(handData);
  const baseUrl = window.location.origin + window.location.pathname;
  return `${baseUrl}?action=${encodedData}`;
};

/**
 * 从 URL 中提取并解码牌局数据
 * @returns {Object|null} - 牌局数据或 null
 */
export const extractHandDataFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const encodedData = params.get('action');
  
  if (!encodedData) {
    return null;
  }
  
  try {
    return decodeGameState(encodedData);
  } catch (error) {
    console.error('Failed to extract hand data from URL:', error);
    return null;
  }
}; 